import { BROADCAST_SCENE_ORDER_UPDATE } from 'actions/Types';
import { withCurrentParams } from 'actions/utils';
import { SCENE_CREATE } from 'store/eventConstants';

export default (sceneId, index) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_SCENE_ORDER_UPDATE,
        request: async apiClient => {
          const { scenes } = await apiClient.broadcast.updateSceneOrder(
            teamId,
            eventId,
            broadcastId,
            sceneId,
            { index }
          );

          const {
            meeting: { attendeeResponse }
          } = getState();

          socket.emit(SCENE_CREATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          return { scenes };
        }
      };
      dispatch(action);
    }
  );
};
